import React, {
  useEffect,
  useState,
  useContext,
  useCallback,
  useRef,
} from 'react';
import { Modal } from 'react-bootstrap';

import { toast } from 'react-toastify';
import { LojaContext } from '~/context/loja';
import api from '~/services/api';

import { useProduto } from '~/pages/Produto/hooks/useProduto';

import { useForm } from 'react-hook-form';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { BuscaProduto } from '~/components/NovosInputs';

interface IModalTransferir {
  show: boolean;
  gtin: string;
  handleModal: (value: boolean) => void;
}

interface FormTransferir {
  cod_produto: {
    value: string;
    isInvalid: boolean;
    isRequired: boolean;
  };
}

const ModalTransferir: React.FC<IModalTransferir> = ({
  show,
  gtin,
  handleModal,
}) => {
  const { formProduto, changeFormProduto } = useProduto();
  const divInput = useRef<HTMLDivElement | null>(null);

  const { loja } = useContext(LojaContext);

  const [formTransferir, setFormTransferir] = useState<FormTransferir>({
    cod_produto: {
      value: '',
      isInvalid: true,
      isRequired: true,
    },
  });
  const [transferindo, setTransferindo] = useState(false);
  const {
    register,
    control,
    setValue,
    formState: { errors },
    clearErrors,
    setError,
  } = useForm();

  useEffect(() => {
    if (!show) {
      setFormTransferir({
        ...formTransferir,
        cod_produto: {
          value: '',
          isRequired: true,
          isInvalid: true,
        },
      });
    }
  }, [show]);

  useEffect(() => {
    setTimeout(() => {
      if (show && divInput.current) {
        const input: HTMLInputElement | null = divInput.current.querySelector(
          '[name="cod_produto"]',
        );

        if (input) {
          input.click();
          input.focus();
        }
      }
    }, 200);
  }, [show]);

  function handleClose() {
    setValue('cod_produto', { value: undefined, label: '' });
    handleModal(false);
  }

  async function handleTransferir() {
    try {
      if (validaInputsParaSubmit(formTransferir)) {
        setError('cod_associado', { type: 'required' });
        return;
      }

      clearErrors('cod_associado');

      if (formTransferir.cod_produto.value === formProduto.cod_produto.value) {
        toast.warn(
          'Os produtos selecionados são iguais. Por favor, selecione um produto diferente.',
        );
        return;
      }

      setTransferindo(true);

      const reg = {
        cod_produto: formTransferir.cod_produto.value,
        cod_produto_origem: formProduto.cod_produto.value,
        cod_gtin: gtin,
        cod_loja: loja.cod_loja,
      };

      const res = await api.post('/produto/gtin/transferir', reg);
      const { success, message } = res.data;

      if (!success) {
        setTransferindo(false);
        throw new Error(message);
      }

      const newGtins = formProduto.Gtins.gtins.filter((item) => {
        return item.cod_gtin.value !== gtin;
      });

      const newEmbalagens = formProduto.Embalagens.embalagens.filter((item) => {
        return item.cod_gtin.value.value !== gtin;
      });

      changeFormProduto({
        ...formProduto,
        Embalagens: {
          ...formProduto.Embalagens,
          embalagens: newEmbalagens,
        },
        Gtins: {
          ...formProduto.Gtins,
          gtins: newGtins,
        },
      });

      toast.success(message);
      handleClose();
    } catch (error: any) {
      toast.warning(error.message);
      handleClose();
    } finally {
      setTransferindo(false);
    }
  }

  const validaInputsParaSubmit = useCallback(
    (inputs: FormTransferir): boolean => {
      for (let i = 0; i < Object.keys(inputs).length; i++) {
        if (
          formTransferir[Object.keys(inputs)[i] as keyof FormTransferir]
            .isRequired &&
          formTransferir[Object.keys(inputs)[i] as keyof FormTransferir]
            .isInvalid
        ) {
          return true;
        }
      }
      return false;
    },
    [formTransferir],
  );

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body
        style={{
          font: "14px 'Jost',sans-serif!important",
        }}
      >
        <div className="row">
          <h2
            style={{
              textAlign: 'center',
            }}
          >
            Atenção
          </h2>
          <div className="col-sm-12 col-md-12">
            <p
              style={{
                textAlign: 'center',
                fontSize: '1.25rem',
                marginBottom: '0.5rem',
                color: '#f75e5e',
              }}
            >
              {`TRANSFERIR o código GTIN para outro produto inativará todas as
              suas embalagens em todas as lojas.`}
            </p>
            <p
              style={{
                fontWeight: 500,
                fontSize: '1rem',
                marginTop: '1rem',
                marginBottom: '0.25rem',
              }}
            >{`GTIN ${gtin} vai para:`}</p>
          </div>
          <div className="col-sm-12 col-md-12" ref={divInput}>
            <BuscaProduto
              label="Produto *"
              placeholder="Informe pelo menos 3 caracteres do Código, Descrição ou GTIN"
              name="cod_produto"
              customOptions={{
                hideBuscarPor: true,
                showSelecionarItensContendo: false,
                buscarPor: ['Associados'],
                buscaDerivados: false,
                buscaPadrao: 'Associados',
              }}
              register={register}
              control={control}
              disabled={false}
              setValue={setValue}
              buscaNasLojas={loja.cod_loja}
              isError={!!errors.cod_associado}
              getProduct={(selected: any) => {
                const produto = selected[0];
                setFormTransferir({
                  ...formTransferir,
                  cod_produto: {
                    ...formTransferir.cod_produto,
                    value: produto.cod_produto,
                    isInvalid: produto.cod_produto === undefined,
                  },
                });
                clearErrors('cod_associado');
              }}
            />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="d-flex align-items-center">
        <CustomButtonNovo
          onClick={async () => {
            await handleTransferir();
          }}
          label="Transferir"
          variant="confirm"
          disabled={transferindo}
        />

        <CustomButtonNovo
          onClick={handleClose}
          label="Cancelar"
          variant="cancel"
          disabled={transferindo}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ModalTransferir;
